import {
	ADMINGETCURRENCYMAPPING_SUCCESS,
	ADMINGETCURRENCYMAPPING_FAILED,
	RESET_ADMINGETCURRENCYMAPPING,
	LOADING_ADMINGETCURRENCYMAPPING,
	NETWORK_ERROR_ADMINGETCURRENCYMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetCurrencyMapping = () => {
	return { type: RESET_ADMINGETCURRENCYMAPPING };
};

const adminGetCurrencyMapping = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETCURRENCYMAPPING });
	await adminServices
		.post("getCurrencyMappingList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetCurrencyMappingsuccess(res.data));
					break;
				default:
					dispatch(adminGetCurrencyMappingFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETCURRENCYMAPPING,
				payload: err
			});
		});
};
function adminGetCurrencyMappingsuccess(data) {
	return {
		type: ADMINGETCURRENCYMAPPING_SUCCESS,
		payload: data
	};
}
function adminGetCurrencyMappingFailed(data) {
	return {
		type: ADMINGETCURRENCYMAPPING_FAILED,
		payload: data
	};
}

export { resetAdminGetCurrencyMapping, adminGetCurrencyMapping };
